import { useEffect, useState } from "react";
import { Radio, Select } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { getQueryParamsOrderForm } from "../../../services/order-add-edit-service";
import useUserStore from "../../../stores/store";

export default function OrderTypeComponent({
  orderType,
  takeoutType,
  context,
  onHandleOrderType,
  onHandleTakeoutType,
}) {
  const { isTableManagement, isTakeout } = getQueryParamsOrderForm();
  const [takeoutOptions, setTakeoutOptions] = useState([]);
  const { takeoutTypes } = useUserStore();

  const getLabel = (hasTableManagement, isTakoutOrder, takeoutOptions = []) => {
    if (hasTableManagement && isTakoutOrder) {
      return takeoutOptions.length > 0 ? "Takeout Type" : "";
    }

    return "Order Type";
  };

  useEffect(() => {
    const mTypes = takeoutTypes.map((text) => {
      return {
        label: text,
        value: text,
      };
    });
    setTakeoutOptions(mTypes);
  }, [takeoutTypes]);

  // Setting order type on the background for table management system
  useEffect(() => {
    if (isTableManagement && isTakeout) {
      onHandleOrderType({ target: { value: "Takout" } });
    }

    if (isTableManagement && !isTakeout) {
      onHandleOrderType({ target: { value: "Dine-in" } });
    }
  }, [isTableManagement, isTakeout]);

  return (
    <div className="mt-4 text-black flex flex-col lg:flex-row items-start lg:items-center gap-2">
      <p className="text-[16px] font-medium">{getLabel(isTableManagement, isTakeout, takeoutOptions)}</p>
      {!isTableManagement && (
        <div className="flex items-center">
          <div className="radio-wrapper">
            <Radio.Group
              value={orderType}
              disabled={context === 1}
              onChange={(e) => onHandleOrderType(e)}
              className="custom-radio-group"
            >
              <Radio.Button value="Dine-in" className="custom-radio-btn">
                <div className="radio-content">
                  {orderType === "Dine-in" ? (
                    <div className="selected-circle">
                      <CheckOutlined />
                    </div>
                  ) : (
                    <div className="unselected-circle" />
                  )}
                  <span className="radio-label">Dine-in</span>
                </div>
              </Radio.Button>
              <Radio.Button value="Takeout" className="custom-radio-btn" disabled={context === 1}>
                <div className="radio-content">
                  {orderType === "Takeout" ? (
                    <div className="selected-circle">
                      <CheckOutlined />
                    </div>
                  ) : (
                    <div className="unselected-circle" />
                  )}
                  <span className="radio-label">Takeout</span>
                </div>
              </Radio.Button>
            </Radio.Group>
          </div>
          {orderType !== "Dine-in" && takeoutOptions.length > 0 && (
            <div className="w-[200px] ml-2">
              <Select
                className="w-full h-[36px]"
                showSearch={false}
                placeholder="Select"
                optionFilterProp="label"
                onChange={onHandleTakeoutType}
                options={takeoutOptions}
                value={takeoutType || null}
              />
            </div>
          )}
        </div>
      )}
      {isTableManagement &&  (
        <>
          {isTakeout && takeoutOptions.length > 0 ? (
            <div className="w-[200px] ml-2">
              <Select
                className="w-full h-full"
                showSearch={false}
                placeholder="Select"
                optionFilterProp="label"
                onChange={onHandleTakeoutType}
                options={takeoutOptions}
                value={takeoutType || null}
              />
            </div>
          ) : (
            <div>Dine-in </div>
          )}
        </>
      )}
    </div>
  );
}
